export default {
  home: "หน้าเเรก",
  companyProfile: "โปรไฟล์ธุรกิจ",
  jobPost: "งาน",
  booking: "จองสัมภาษณ์",
  manage: "จัดการคิว",
  manageFund: "จัดการทุน",
};
